<template>
  <b-modal
    id="confirm-save-credit-card-modal"
    title="Confirm"
    centered
    @shown="loading = false">
    <p class="text-center">Are you sure you want to add this card as payment method?</p>
    <template slot="modal-footer">
      <b-button
        @click="$root.$emit('bv::hide::modal', 'confirm-save-credit-card-modal')"
        :disabled="loading">
        Cancel
      </b-button>
      <b-button
        variant="primary"
        @click="handleAddPaymentMethod"
        :disabled="loading">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  methods: {
    handleAddPaymentMethod() {
      this.loading = true;
      this.$root.$emit('createXenditToken')
    }
  }
}
</script>
